<template>
  <div class="col_2 w934 onsite_b task_jihua_list">
    <h5 class="none_ts" v-if="cntData <= 0 || !lists" style="text-align: center;">
      <img src="@/assets/images/none_data.jpg" alt="">
      <h4>暂无课程</h4>
    </h5>
    <dl v-for="item in lists" :key="item.id">
      <dt>
        <span class="btn_end" v-if="item.per == 100">已完成</span>
        <img src="@/assets/images/course_default.png" v-if="!item.faceUrl || item.faceUrl == ''" />
        <img :src="item.faceUrl" v-if="item.faceUrl && item.faceUrl !== ''">
      </dt>
      <dd class="narrow">
        <h3>{{item.name}}</h3>
        <!--p class="time_t">开始学习时间： {{ dateFormat(new Date(item.updateTime), 'yyyy-MM-dd hh:mm:ss') }}</p-->
        <a class="a_detail" @click="to({id: item.id})" style="cursor: pointer;">查看进度 {{item.per}}%</a>
      </dd>
    </dl>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import Paginate from 'vuejs-paginate'
  import { getCookie } from '@/store/cookies'
  import utils from '@/utils'
  export default {
    components: { Paginate },
    data () {
      return {
        lists: [],
        filters: {
          pageNo: 1,
          pageSize: 12,
          itemType: '00'
        },
        pages: 0,
        cntData: ''
      }
    },
    created () {
      this.search(this.filters)
    },
    methods: {
      dateFormat: utils.dateFormat,
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      to (o) {
        var path = getCookie('org') ? this.$OR.getUrl(getCookie('org').businessId) : ''
        this.$router.push({
          path: path + '/courseDetail/' + o.id
        })
      },
      search (filters) {
        api.post(config.bylApiPath, '/studyItemPermissions/myTasks', filters, (r) => {
          this.lists = r.data
          this.cntData = r.cntData // 总数
          this.pages = Math.ceil(r.cntData / this.filters.pageSize) // 页数
        })
      },
      goCheck (item) {
        switch (item.type) {
          case '01': {
            this.$router.push({path: '/continueEdu/courseDetail/'+ item.businessId})
            break
          }
          case '02': {
            this.$router.push({path: '/continueEdu/livePlay/'+ item.businessId})
            break
          }
          case '03': {
            this.$router.push({path: '/continueEdu/plan/'+ item.businessId})
            break
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/modules/task/myCourse.vue